import React, { useState } from "react";
import { Button, Form, Icon, Tooltip } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";
import { SelectAssetsModal } from "../../../../Asset/components/SelectAssetsModal";
import { AssetService, AssetImageType, IAssetModel } from "@xala/common-services";
import { DeepLinkHelper } from "@xala/common-services/src/helpers/deeplink.helper";
import { NOTIFICATION_TITLE_MAX_LENGTH } from "./TitleField";
import { NOTIFICATION_TEXT_CONTENT_MAX_LENGTH } from "./TextContentField";

const assetService = new AssetService().promisify();

export const SelectAssetField = ({
  notification,
  isHidden,
  form,
}: INotificationField) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  if (isHidden || notification?.Provider === "EMAIL") {
    return null;
  }

  const onSelect = async (asset: IAssetModel) => {
    setVisible(false);

    const assetResponse = await assetService.getAsset(asset.Id);

    if (!assetResponse.ok) {
      return;
    }

    const frameImage = assetResponse.data?.Images?.find(
      (img) => img.AssetImageTypeCode === AssetImageType.Frame
    );
    if (frameImage?.Url) {
      form?.setFieldsValue({ ImageUrl: frameImage.Url });
    }

    if (assetResponse.data?.Title) {
      form?.setFieldsValue({ Title: assetResponse.data.Title.substring(0, NOTIFICATION_TITLE_MAX_LENGTH) });
    }

    if (assetResponse.data?.ShortDescription) {
      form?.setFieldsValue({ TextContent: assetResponse.data.ShortDescription.substring(0, NOTIFICATION_TEXT_CONTENT_MAX_LENGTH) });
    }

    const deepLinkUrl = DeepLinkHelper.createDeepLinkUrl(assetResponse.data);

    if (deepLinkUrl) {
      form?.setFieldsValue({ DeepLink: deepLinkUrl });
    }
  }

  return (
    <Form.Item
      name="SelectAsset"
      label={
        <span>
          {t("NOTIFICATION_SELECT_ASSET_FIELD")}&nbsp;
          <Tooltip title="En aquest camp es selecciona un media de la biblioteca, per tal d'emplenar de forma automàtica el contingut de la notificació amb la informació del vídeo seleccionat. Tot i que aquestes dades són necessàries per enviar la notificació, no és obligatori afegir-les des d'un asset. Es poden emplenar tots els camps manualment o modificar-los posteriorment">
            <Icon type="question-circle" />
          </Tooltip>
        </span>
      }
      key="SelectAsset"
    >
      <Button onClick={() => setVisible(true)}>
        {t("BUTTON_SELECT_ASSET", "Select Asset")}
      </Button>
      <SelectAssetsModal
        visible={visible}
        onClose={() => {
          setVisible(false);
        }}
        onSelect={onSelect}
      />
    </Form.Item>
  );
};
